<template>
  <div v-show="usablePointCards.length > 0" class="pointCardsWrap">
    <div v-if="usableTimeCards.length" class="pointCardTitle">
      {{ TLang("点卡", "orderConfirm") }}
    </div>
    <div class="pointCards">
      <div
        v-for="(card, index) in usablePointCards"
        :key="card.cardNo + index"
        :class="[
          'pointCard',
          card.checked === 'Y' ? 'selected' : '',
          card.ashing ==='1' ? 'unUseCard' : '',
        ]"
        @click="clickPointCard(card)"
      >
        <div class="pointCardInfo">
          <!-- 判断卡卷是否是工会的 -->
          <div
            class="cardName"
            :class="{'unUseColor':card.ashing === '1' }"
          >
            {{ unionF ? card.kindForeignName : card.kindName }}
          </div>
          <div
            class="cardTxt"
            :class="{'unUseColor': card.ashing === '1'}"
            v-if="formatBalance(card.showBalance)[0] != 0"
          >
            {{ TLang("可用余额", "orderConfirm") }}({{
              cardInfo && cardInfo.name
                ? cardInfo.name
                : TLang("福豆", "orderConfirm")
            }})
          </div>
          <div
            class="cardTxtTwo"
            v-if="formatBalance(card.showBalance)[0] == 0"
          >
            {{ TLang("可用余额", "orderConfirm") }}({{
              cardInfo && cardInfo.name
                ? cardInfo.name
                : TLang("福豆", "orderConfirm")
            }})
          </div>
          <div
            class="cardBalance"
            :class="[card.ashing === '1' ? 'unUseColor' : '']"
            v-if="formatBalance(card.showBalance)[0] != 0"
          >
            {{ formatBalance(card.showBalance)[0]
            }}<em>.{{ formatBalance(card.showBalance)[1] }}</em>
          </div>
          <div
            class="cardBalanceTwo"
            v-if="formatBalance(card.showBalance)[0] == 0"
          >
            {{ formatBalance(card.showBalance)[0]
            }}<em>.{{ formatBalance(card.showBalance)[1] }}</em>
          </div>
          <div class="cardNo">
            {{ TLang("卡号", "card") }}:{{ card.cardNo }}
          </div>
          <div class="cardRange">
            <span
              class="cardTime"
              v-if="!cardExpireShowType || cardExpireShowType === 1"
            >
              {{ TLang("有效期至", "card")
              }}<span
                :class="[card.fastExpiration === 'Y' ? 'red-font' : '']"
                >{{ formatTime(card.expireDate) }}</span
              ></span
            >
            <span class="cardTime" v-else-if="cardExpireShowType === 2">
              {{ TLang("有效期至", "card")
              }}<span>{{ TLang("长期有效", "card") }}</span></span
            >
            <span class="cardTips">
              <el-popover
                popper-class="useScope"
                placement="bottom-start"
                title=""
                max-width="300"
                trigger="hover"
                :content="card.kindDesc"
              >
                <div slot="reference"
                  ><img :src="require('@/assets/images/order/tips.png')" /><em
                    class="tipTxt"
                    >&nbsp; {{ TLang("使用范围", "orderConfirm") }}</em
                  ></div
                >
              </el-popover>
            </span>
          </div>
          <img
            class="selectedImg"
            :src="require('@/assets/images/selected.png')"
          />
        </div>
        <div
          v-if="card.ashing == '1' && card.unavailableDesc"
          class="unUsedReason"
        >
          <img :src="require('@/assets/images/icon_deliver_tip.png')" />{{
            card.unavailableDesc
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from "@components/simpleToast";

import { unionFlag } from "@utils";
import { payTotastNames } from "@utils/config";
export default {
  name: "PointCard",
  props: {
    // 卡数据
    interestsInfo: Object,
    allSelectCard: Object,
    sendGio: Function,
  },
  data() {
    return {
      cards: JSON.parse(JSON.stringify(this.interestsInfo)),
      now: new Date().getTime(),
      unionF: unionFlag() || sessionStorage.getItem("dffl_union"),
    };
  },
  computed: {
    // 卡信息
    cardInfo() {
      if (this.cards && this.cards.cardInfo) {
        return this.cards.cardInfo;
      }
      return {};
    },
    cardExpireShowType() {
      if (this.cards && this.cards.cardExpireShowType) {
        return this.cards.cardExpireShowType;
      }
      return null;
    },
    // 可用点卡
    usablePointCards() {
      if (
        this.cardInfo &&
        this.cardInfo.usableCardInfo &&
        this.cardInfo.usableCardInfo.pointCardList &&
        this.cardInfo.usableCardInfo.pointCardList.length > 0
      ) {
        return this.cardInfo.usableCardInfo.pointCardList;
      }
      return [];
    },
    // 可用次卡
    usableTimeCards() {
      if (
        this.cardInfo &&
        this.cardInfo.usableCardInfo &&
        this.cardInfo.usableCardInfo.goodsCardList &&
        this.cardInfo.usableCardInfo.goodsCardList.length > 0
      ) {
        return this.cardInfo.usableCardInfo.goodsCardList;
      }
      return [];
    },
  },
  watch: {
    interestsInfo: {
      handler(val) {
        this.cards = JSON.parse(JSON.stringify(val));
      },
      deep: true,
    },
  },
  methods: {
    clickPointCard(card) {
      if (card.ashing === '1') {
        return;
      }
      // 先判断次卡点卡是否互斥

      const newCards = JSON.parse(JSON.stringify(card));
      // 订单实付金额
      const orderAmount = this.interestsInfo.paymentAmount || 0;
      const totalTimeCardMoney =
        this.cardInfo.usableCardInfo.totalTimeCardMoney || 0;
      const totalPointMoney = this.cardInfo.usableCardInfo.totalPointMoney || 0;
      // 当前除次卡。点卡外 ，最大还需抵扣金额
      const max = orderAmount - totalTimeCardMoney - totalPointMoney;
      const now = new Date().getTime();
      if (newCards.checked === "Y") {
        newCards.checked = "N";
        if (now - this.now > 500) {
          this.now = now;
          // 调接口
          this.handlePaymentParam("N", newCards);
        }
      } else {
        if (!this.$parent.$parent.enableSelect) {
          Toast.info(payTotastNames.noRemainPay, 1.5);
          return;
        }

        // 是否互斥 Y互斥  不互斥
        if (
          this.interestsInfo &&
          this.interestsInfo.cardInfo &&
          this.interestsInfo.cardInfo.dfCardExclusion === "Y"
        ) {
          // 次卡抵扣不为零
          if (
            this.interestsInfo.cardInfo.usableCardInfo &&
            this.interestsInfo.cardInfo.usableCardInfo.totalTimeCardMoney
          ) {
            Toast.info(payTotastNames.timeOrPointCard, 1.5);
            return;
          }
        }

        if (max > 0 && now - this.now > 500) {
          this.now = now;
          // 调接口
          newCards.checked = "Y";
          this.handlePaymentParam("Y", newCards);
        }
      }
    },
    handlePaymentParam(status, item) {
      var allCard = this.$parent.$parent.allSelectCard;
      allCard.chooseType = 1;
      // 取消选中状态
      if (status === "N") {
        this.sendGio("福利卡", "选择福利卡", {
          status: "取消勾选",
          contentTitle: item.kindName,
        });
        if (allCard.pointCards && allCard.pointCards.length) {
          let index = allCard.pointCards.findIndex(
            (obj) => obj.cardNo === item.cardNo
          );
          if (index > -1) {
            allCard.pointCards.splice(index, 1);
          }
        }
      } else if (status === "Y") {
        this.sendGio("福利卡", "选择福利卡", {
          status: "勾选",
          contentTitle: item.kindName,
        });
        let obj = {};
        obj.cardNo = item.cardNo;
        obj.value = item.checkedValue;
        let index = allCard.pointCards.findIndex(
          (obj) => obj.cardNo === item.cardNo
        );
        if (index > -1) {
          allCard.pointCards.splice(index, 1, obj);
        } else {
          allCard.pointCards.push(obj);
        }
      }
      this.$parent.$parent.getChooseData(allCard);
    },
    formatBalance(balance) {
      if (!balance) {
        return ["0", "00"];
      }
      const newBalance = Number((balance * window.union_scale) / 100).toFixed(
        2
      );
      return newBalance.split(".");
    },
    formatTime(str) {
      if (!str) {
        return "";
      }
      return str.replace(/\-/g, ".");
    },
  },
};
</script>

<style lang="less" scoped>
.pointCardsWrap {
  .pointCardTitle {
    padding: 12px 23px;
    background: #f7f7f7;
  }
  .pointCards {
    padding: 16px 0 0 24px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
  .pointCard {
    width: 270px;
    margin-right: 24px;
    margin-bottom: 24px;
    background: #f8fcff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    cursor: pointer;
  }
  .unUseCard {
    background: #f6f6f7;
  }
  .pointCardInfo {
    padding: 12px;
    position: relative;
  }
  .pointCard:nth-child(4n) {
    margin-right: 0;
  }
  .cardName {
    max-height: 48px;
    font-size: 16px;
  
    color: #111111;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
  }
  
  .cardTxt {
    padding-top: 12px;
    font-size: 12px;
  
    font-weight: 400;
    color: #3d96e2;
  }
  .cardTxtTwo {
    padding-top: 12px;
    font-size: 12px;
  
    font-weight: 400;
    color: #333;
  }
  .cardBalance {
    font-size: 24px;
  
    font-weight: 500;
    color: #3d96e2;
    em {
      font-size: 12px;
    }
  }
  .cardBalanceTwo {
    font-size: 24px;
  
    font-weight: 500;
    color: #333;
    em {
      font-size: 12px;
    }
  }
  .cardNo {
    margin: 12px 0;
    font-size: 12px;
  
    color: #666666;
  }
  .red-font {
    color: #f44545;
  }
  .cardRange {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  
    color: #666666;
  }
  .cardTime {
    text-align: left;
  }
  .cardTips {
    text-align: right;
    img {
      margin-right: -2px;
      width: 12px;
      height: 12px;
      vertical-align: middle;
      margin-top: -1.8px;
    }
    .tipTxt {
      color: #999;
      cursor: pointer;
    }
  }
  .selectedImg {
    display: none;
  }
  .pointCard.selected {
    border: 2px solid #3d96e2;
  }
  .pointCard.selected .selectedImg {
    display: block;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 0;
    top: 0;
  }
  .pad-0 {
    padding-bottom: 0;
  }
  .unUsedReason {
    padding: 4px 12px;
    background: #f6f6f7;
    border-top: 1px solid #e5e5e5;
    font-size: 12px;
    font-weight: 400;
    color: #f44545;
    img {
      width: 12px;
      height: 12px;
      padding-right: 5px;
      vertical-align: top;
      margin-top: 3px;
    }
  }
  .unUseColor {
    color: #333;
  }
}
.useScope {
  font-size: 14px;

  color: #333333;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
</style>


